import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  const checkoutUrl = 'https://www.yennilemon.com/cart/44211058212999:1';
  return <section className="relative bg-warm-white overflow-hidden py-12 md:py-20 lg:py-24 px-6 md:px-4" data-id="element-128">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-129">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-4 md:space-y-6" data-id="element-130">
          <span className="text-sage font-bold tracking-widest text-xs md:text-sm uppercase text-center md:text-left" data-id="element-131">
            Para mujeres +40 que buscan armonía
          </span>

          {/* Mobile headline */}
          <h1 className="md:hidden text-[clamp(28px,7vw,36px)] font-heading font-bold text-olive leading-tight text-center" data-id="element-132">
            Equilibra tus hormonas
            <br data-id="element-133" />y desinflama el abdomen.
          </h1>
          {/* Desktop headline */}
          <h1 className="hidden md:block text-5xl lg:text-6xl font-heading font-bold text-olive leading-tight" data-id="element-134">
            Desinflama tu abdomen y recupera tu energía después de los 40.
          </h1>

          {/* Desktop subheadline — hidden on mobile */}
          <p className="hidden md:block text-xl text-warm-gray leading-relaxed max-w-xl" data-id="element-135">
            Plan antiinflamatorio práctico para mujeres +40 que desean reducir
            inflamación, equilibrar hormonas y recuperar su energía sin dietas
            milagrosas.
          </p>

          {/* Mobile ebook image — shown only on mobile, between headline and pricing */}
          <div className="md:hidden flex justify-center mt-2" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/wGV6FdLUgwCFMi4G1vf84W/PORTADA3D_(2).png" alt="Plan Antiinflamatorio Después de los 40 Ebook" className="max-w-[280px] w-full h-auto object-contain drop-shadow-2xl" data-id="element-137" />
          </div>

          {/* Benefit pills — hidden on mobile */}
          <div className="hidden md:flex flex-col gap-3 py-2" data-id="element-138">
            {[{
            icon: '🔥',
            text: 'Activa tu metabolismo sin dietas extremas'
          }, {
            icon: '⚡',
            text: 'Recupera tu energía y equilibrio hormonal'
          }, {
            icon: '📖',
            text: 'Guía práctica con resultados reales'
          }].map((pill, idx) => <div key={idx} className="flex items-center gap-3 bg-cream px-4 py-3 rounded-xl border border-sage/20 w-fit" data-id="element-139">
                <span className="text-xl" data-id="element-140">{pill.icon}</span>
                <span className="text-olive font-medium text-sm md:text-base" data-id="element-141">
                  {pill.text}
                </span>
              </div>)}
          </div>

          {/* Pricing Block */}
          <div className="mt-4 bg-cream border-2 border-sage rounded-2xl p-6 md:p-8 text-center max-w-md mx-auto lg:mx-0 shadow-soft relative" data-id="element-142">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-sage text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap" data-id="element-143">
              👇 PRECIO DE LANZAMIENTO
            </div>

            <div className="flex flex-col items-center justify-center space-y-1 mt-2" data-id="element-144">
              <div className="flex items-center gap-2 text-warm-gray text-sm" data-id="element-145">
                <span data-id="element-146">Precio regular:</span>
                <span className="line-through decoration-warm-accent/50" data-id="element-147">
                  $19.99 USD
                </span>
                <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-148">
                  -50% OFF
                </span>
              </div>

              <div className="text-5xl md:text-6xl font-bold text-olive font-heading py-2" data-id="element-149">
                $6.36 <span className="text-2xl md:text-3xl" data-id="element-150">USD</span>
              </div>

              <p className="text-sage font-medium text-sm" data-id="element-151">
                Solo por 3 días · Oferta de lanzamiento
              </p>

              <p className="text-warm-gray italic text-xs pt-2" data-id="element-152">
                Pago único · Sin suscripciones · Descarga inmediata
              </p>
            </div>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full mt-6 bg-sage hover:bg-sage-dark text-white font-bold py-4 px-8 rounded-full transition-all transform hover:scale-[1.02] shadow-md text-lg text-center" data-id="element-153">
              ✨ Quiero empezar hoy — $6.36 USD
            </a>

            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mt-4 text-xs text-olive font-medium" data-id="element-154">
              <span className="flex items-center gap-1" data-id="element-155">
                <Check className="w-3 h-3 text-sage" data-id="element-156" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-157">
                <Check className="w-3 h-3 text-sage" data-id="element-158" /> Pago único
              </span>
              <span className="flex items-center gap-1" data-id="element-159">
                <Check className="w-3 h-3 text-sage" data-id="element-160" /> Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>

        {/* Image Content — desktop only */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative hidden lg:flex justify-center lg:justify-end" data-id="element-161">
          <div className="relative w-full max-w-lg" data-id="element-162">
            {/* Decorative background blob */}
            <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-163"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wGV6FdLUgwCFMi4G1vf84W/PORTADA3D_(2).png" alt="Plan Antiinflamatorio Después de los 40 Ebook" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-164" />
          </div>
        </motion.div>
      </div>
    </section>;
}